/* Already Loved Club — store reviews (imported from Depop).
   Renders assets/alc-reviews.json into the section markup, with search, sort
   and rating filter. Fetched lazily: the file is ~66KB and every product page
   embeds this section, so it is not inlined into the HTML. */
(function () {
  'use strict';

  var root = document.querySelector('[data-alc-reviews]');
  if (!root) return;

  var listEl = root.querySelector('[data-alc-rv-list]');
  var countEl = root.querySelector('[data-alc-rv-count]');
  var moreEl = root.querySelector('[data-alc-rv-more]');
  var qEl = root.querySelector('[data-alc-rv-q]');
  var sortEl = root.querySelector('[data-alc-rv-sort]');
  var rateEl = root.querySelector('[data-alc-rv-rating]');

  var PAGE = 8;
  var all = [];
  var view = [];
  var shown = 0;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function stars(n) {
    var full = '★★★★★'.slice(0, n);
    var empty = '☆☆☆☆☆'.slice(0, 5 - n);
    return '<span class="alcrv-cstars" aria-label="' + n + ' out of 5">' +
      full + '<span class="alcrv-coff">' + empty + '</span></span>';
  }

  function when(d) {
    if (!d) return '';
    var p = d.split('-');
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[parseInt(p[1], 10) - 1] + ' ' + p[0];
  }

  function card(r) {
    // 44 reviews have no handle (deleted Depop accounts) — never render "@".
    var name = r.u ? '@' + r.u : 'Depop buyer';
    var initial = (r.u ? r.u[0] : 'D').toUpperCase();
    return '<article class="alcrv-card">' +
      '<div class="alcrv-av" aria-hidden="true">' + esc(initial) + '</div>' +
      '<div class="alcrv-body">' +
        '<div class="alcrv-head">' +
          '<span class="alcrv-name">' + esc(name) + '</span>' +
          '<span class="alcrv-date">' + esc(when(r.d)) + '</span>' +
        '</div>' +
        stars(r.s) +
        '<p class="alcrv-text">' + esc(r.t) + '</p>' +
        '<div class="alcrv-verified">Verified purchase · Depop</div>' +
      '</div>' +
    '</article>';
  }

  function apply() {
    var q = (qEl.value || '').trim().toLowerCase();
    var rate = rateEl.value;
    view = all.filter(function (r) {
      if (rate && String(r.s) !== rate) return false;
      if (q && (r.t + ' ' + r.u).toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
    var s = sortEl.value;
    if (s === 'recent') view.sort(function (a, b) { return a.d < b.d ? 1 : -1; });
    // "Most detailed" ranks by length, but a five-star rating whose TEXT is a
    // complaint ("took 5 weeks", "never received it") is common on Depop and
    // would otherwise lead this view. `f` marks the clean, substantive ones, so
    // flagged reviews sort last here. They are NOT hidden — still returned by
    // search, by Most recent, and by the rating filter — just not the first
    // thing a shopper reads under a heading that implies a highlight.
    else if (s === 'helpful') view.sort(function (a, b) {
      return (b.f - a.f) || (b.t.length - a.t.length);
    });
    else if (s === 'high') view.sort(function (a, b) { return b.s - a.s || (a.d < b.d ? 1 : -1); });
    else if (s === 'low') view.sort(function (a, b) { return a.s - b.s || (a.d < b.d ? 1 : -1); });
    shown = 0;
    listEl.innerHTML = '';
    render();
  }

  function render() {
    var next = view.slice(shown, shown + PAGE);
    listEl.insertAdjacentHTML('beforeend', next.map(card).join(''));
    shown += next.length;
    moreEl.hidden = shown >= view.length;
    countEl.textContent = view.length
      ? 'Showing ' + shown + ' of ' + view.length + (view.length === 1 ? ' review' : ' reviews')
      : 'No reviews match that search.';
  }

  // Only fetch when the section is actually approaching the viewport — it sits
  // at the bottom of every product page and most visitors never reach it.
  var loaded = false;
  function load() {
    if (loaded) return;
    loaded = true;
    fetch(root.getAttribute('data-src'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        all = (data && data.reviews) || [];
        apply();
      })
      .catch(function () {
        listEl.innerHTML = '<div class="alcrv-loading">Reviews are taking a moment — ' +
          '<a href="https://www.depop.com/alexisren/" target="_blank" rel="noopener">read them on Depop</a>.</div>';
      });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { load(); io.disconnect(); }
    }, { rootMargin: '600px' });
    io.observe(root);
  } else {
    load();
  }

  moreEl.addEventListener('click', render);
  var t;
  qEl.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 180); });
  sortEl.addEventListener('change', apply);
  rateEl.addEventListener('change', apply);
})();
